import { compact } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetAuthUser, useLogoutMutation } from '../../../api/queries/auth';
import { Path } from '../../../enums';
import { Category, ICategoryItem } from './Category';

export const Support: React.FC = () => {
    const { t } = useTranslation();

    const logoutMutation = useLogoutMutation();
    const authUser = useGetAuthUser({ enabled: false });

    const handleLogout = () => {
        logoutMutation.mutate();
    };

    const categoryItems: ICategoryItem[] = compact([
        {
            title: authUser.data?.hasSalesRole
                ? t('common.menu.categories.support.menu.salesAccounts')
                : t('common.menu.categories.support.menu.accounts'),
            url: Path.SUPPORT_ACCOUNTS,
        },
        (authUser.data?.hasSalesRole || authUser.data?.hasSupportRole) && {
            title: t('common.menu.categories.support.menu.statistics'),
            url: Path.SUPPORT_STATISTICS,
        },
        authUser.data?.hasSupportRole && {
            title: t('common.menu.categories.support.menu.users'),
            url: Path.SUPPORT_USERS,
        },
        {
            title: t('common.menu.categories.support.menu.logout'),
            onClick: handleLogout,
        },
    ]);

    return <Category name="support" title={t('common.menu.categories.support.title')} items={categoryItems} open />;
};

export default Support;
